import vuexStore from '@/store';
import { defineStore } from 'pinia';
import { useRenewalsStore } from '@/stores/leasing/renewals';

export const useLeasingStore = defineStore('leasing', {
    state: () => ({
        renewalsStore: useRenewalsStore(),
        payerByPartyIdMap: {},
    }),

    getters: {
        hasPermission: () => permissionAlias =>
            permissionAlias && vuexStore.getters['auth/getAppPermissions']('LEASING')?.includes(permissionAlias),
    },

    actions: {
        setPayerByPartyIdMap(payload) {
            this.payerByPartyIdMap = payload;
        },
    },
});
